import React from "react";
import logo from "../../../assets/logo.png";
import load from "../../../assets/load.png";
import unload from "../../../assets/unload.png";
import goods from "../../../assets/goods.png";
import img from "../../../assets/Picture1.png";
import footerOne from "../../../assets/footerOne.png";
import term from "../../../assets/termss.png";
import {
  Document,
  Page,
  StyleSheet,
  Image,
  Text,
  View,
  pdf,
  Font,
} from "@react-pdf/renderer";
import { AmountFormat } from "../../../lib/helper/amountFormat";
import { calculateVolumeWeight } from "../../../lib/helper/volumeWeight";
import { FormatDate } from "../../../lib/dateFormat";

Font.registerHyphenationCallback((word) => [word]);

const styles = StyleSheet.create({
  rightImage: {
    position: "absolute",
    right: 0,
    top: 0,
  },
  footerOne: {
    position: "absolute",
    left: 0,
    bottom: 0,
    right: 0,
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    borderBottom: "7px solid #DA1C00",
  },
  footerTextContainer: {
    maxWidth: "60%", // Constrain text width to prevent stretching
    textAlign: "center",
  },
  footerTextInside: {
    fontSize: 8,
    color: "gray",
    fontFamily: "Helvetica",
    textAlign: "center",
    marginTop: 5,
    marginBottom: 2, // Reduced spacing between lines
    lineHeight: 1.1, // Control line height more tightly
  },
  footerTextUrl: {
    fontSize: 8,
    color: "gray",
    fontFamily: "Helvetica",
    textAlign: "center",
    marginBottom: 5, // Space below URL to avoid overlap with red line
    lineHeight: 1.1, // Control line height more tightly
  },
  page: {
    flexDirection: "column",
    paddingBottom: "50px",
    paddingLeft: 20,
    paddingRight: 20,
    paddingTop: 20,
    // height: '100vh',
    position: "relative",
  },
  page2: {
    flexDirection: "column",
    // height: '100vh',
    position: "relative",
  },
  section: {
    marginBottom: 10,
  },
  logo: {
    width: 100,
    marginBottom: 10,
  },
  logo1: {
    width: "150px",
    marginBottom: 10,
  },
  companyInfo: {
    marginBottom: 18,
  },
  companyName: {
    color: "#17365d",
    fontSize: 9,
    fontFamily: "Helvetica-Bold",
    marginBottom: 4,
  },
  companyText: {
    fontSize: 8,
    marginBottom: 2,
  },
  logo2: {
    width: 400,
    marginBottom: 5,
  },
  termPage: {
    height: "100vh",
    width: "100%",
  },
  terms: {
    width: "100%",
    marginBottom: 5,
  },
  title: {
    fontSize: 10,
    marginBottom: 5,
    textTransform: "uppercase", // Capitalize text
  },
  title1: {
    color: "red",
    fontSize: "13px",
    marginBottom: 5,
    textTransform: "uppercase", // Capitalize text
  },
  title2: {
    fontSize: 10,
    textTransform: "uppercase", // Capitalize text
  },
  text: {
    fontSize: 10,
    marginBottom: 5,
    padding: "1px 0",
  },
  text1: {
    fontSize: 10,
    marginBottom: 2,
  },
  rowContainer: {
    flexDirection: "row",
    alignItems: "start",
    justifyContent: "space-between",
    gap: 10,
  },
  section1: {
    width: "32%",
    flexDirection: "column",
    gap: 5,
  },
  section2: {
    width: "100%",
    flexDirection: "column",
    gap: 2,
    marginTop: 15,
  },
  imgBox: {
    flexDirection: "row",
    alignItems: "baseline",
    gap: "2px",
    width: "100%",
    borderBottom: "0.5px solid black",
    paddingBottom: 2,
    marginBottom: 3,
    height: 20,
  },
  img: {
    width: 10,
  },
  rowBox: {
    flexDirection: "row",
    gap: 5,
    justifyContent: "space-between",
    padding: 3,
  },
  rowBox1: {
    flexDirection: "row",
    justifyContent: "space-between",
    padding: 3,
  },
  statBox: {
    flexDirection: "column",
    gap: 5,
    marginBottom: 2,
    justifyContent: "start",
  },
  statBox1: {
    flexDirection: "column",
    gap: 5,
    justifyContent: "start",
    width: "20%",
  },
  statBox2: {
    flexDirection: "column",
    gap: 5,
    justifyContent: "start",
    width: "25%",
  },
  statBox3: {
    flexDirection: "column",
    gap: 5,
    justifyContent: "start",
    width: "40%",
  },
  statBox4: {
    flexDirection: "column",
    gap: 5,
    justifyContent: "start",
    width: "13%",
  },
  statBox5: {
    flexDirection: "column",
    gap: 5,
    justifyContent: "start",
    width: "30%",
  },
  statTitle: {
    color: "gray",
    fontSize: 10,
    textTransform: "uppercase",
    // Capitalize text
  },
  statValue: {
    fontSize: 10,
  },
  statValue1: {
    fontSize: 10,
    textTransform: "uppercase",
  },

  totalSection: {
    width: "100%",
    flexDirection: "row",
    justifyContent: "flex-end",
    marginTop: "30px",
    position: "relative",
    bottom: 10, // Adjust marginTop to 'auto' for automatic spacing
    right: 10, // Adjust marginTop to 'auto' for automatic spacing
  },

  totalBox: {
    width: "38%",
    flexDirection: "column",
    borderBottom: "0.5px solid black",
    borderTop: "0.5px solid black",
    gap: 3,
    marginTop: 30, // Remove marginTop from here
    padding: 5,
    alignSelf: "flex-end", // Align the totalBox to the end of the container
  },
  totalLabelCol: {
    flexDirection: "column",
    gap: 5,
    justifyContent: "flex-start",
    width: "48%",
  },
  totalUnitCol: {
    flexDirection: "column",
    gap: 5,
    justifyContent: "flex-start",
    width: "18%",
  },
  totalAmountCol: {
    flexDirection: "column",
    gap: 5,
    justifyContent: "flex-start",
    width: "34%",
  },

  totalRow: {
    flexDirection: "row",
    width: "100%",
    borderBottom: "0.5px solid black",
    gap: 5,
    justifyContent: "space-between",
    padding: 3,
  },
  totalRow1: {
    flexDirection: "row",
    width: "100%",
    // borderBottom: '0.5px solid black',
    gap: 5,
    justifyContent: "space-between",
    padding: 3,
  },
  discountRow: {
    flexDirection: "row",
    width: "100%",
    borderBottom: "0.5px solid #fb923c",
    gap: 5,
    justifyContent: "space-between",
    padding: 3,
    backgroundColor: "#fff7ed",
  },
  discountText: {
    fontSize: 9.5,
    color: "#ea580c",
  },
});

// Helper function to get currency symbol
const getCurrencySymbol = (currency) => {
  switch (currency) {
    case "USD":
      return "$";
    case "GBP":
      return "£";
    case "EUR":
      return "€";
    default:
      return "€"; // Default to Euro
  }
};

const getClientCountry = (formData) =>
  formData?.userCountry ||
  formData?.country ||
  formData?.clientCountry ||
  "-";

const PDFDocument = ({ formData, quotationCreatedByAdmin }) => (
  <Document>
    <Page wrap size="A4" style={styles.page}>
      {/* Check if formData is defined before rendering */}

      {formData && (
        <>
          <View fixed style={styles.rightImage}>
            <Image src={img} style={styles.logo1} />
          </View>
          <Image fixed src={logo} style={styles.logo} />
          <View style={styles.companyInfo}>
            <Text style={styles.companyName}>One Union Solutions B.V.</Text>
            <Text style={styles.companyText}>Legmeerdijk 169C</Text>
            <Text style={styles.companyText}>1432 KA Aalsmeer</Text>
            <Text style={styles.companyText}>Netherlands</Text>
            <Text style={styles.companyText}>P: +31 850600753</Text>
            <Text style={styles.companyText}>E: info@oneunionsolutions.com</Text>
          </View>
          <Text style={styles.title1}>Client</Text>
          <View style={styles.section}>
            <Text style={styles.text}>{formData?.name}</Text>
            <Text style={styles.text}>
              {formData?.address}, {formData?.postalCode}
            </Text>
            <Text style={styles.text}>
              {formData?.city ? `${formData.city}, ` : ""}
              {getClientCountry(formData)}
            </Text>
            <Text style={styles.title1}>
              Quotation Number: {formData?.quoteNumber}
            </Text>
          </View>

          <View style={styles.rowContainer}>
            <View style={styles.section1}>
              <View style={styles.imgBox}>
                <Image src={load} style={styles.img} />
                <Text style={styles.title2}>Load Address</Text>
              </View>
              {/* changes in loadName */}
              {/* <Text style={styles.text1}>{quotationCreatedByAdmin ? formData?.name : formData?.loadName} , </Text>  */}

              <Text style={styles.text1}>
                {formData?.loadAddress_CompanyName}{" "}
              </Text>
              <Text style={styles.text1}>{formData?.loadAddress} , </Text>
              <Text style={styles.text1}>{formData?.loadPostalCode}, </Text>
              <Text style={styles.text1}>{formData?.loadCity} , </Text>
              <Text style={styles.text1}>{formData?.loadCountry} </Text>
            </View>

            <View style={styles.section1}>
              <View style={styles.imgBox}>
                <Image src={unload} style={styles.img} />
                <Text style={styles.title2}>Unload Address</Text>
              </View>
              {/* <Text style={styles.text1}>{formData?.unloadName} , </Text> */}
              <Text style={styles.text1}>
                {formData?.unloadAddress_CompanyName}{" "}
              </Text>
              <Text style={styles.text1}>
                {formData?.unloadAddress && formData.unloadAddress}
              </Text>
              <Text style={styles.text1}>{formData?.unloadPostalCode} , </Text>
              <Text style={styles.text1}>{formData?.unloadCity} , </Text>
              <Text style={styles.text1}>{formData?.unloadCountry} </Text>
            </View>
            <View style={styles.section1}>
              <View style={styles.imgBox}>
                <Text style={styles.title2}>Details</Text>
              </View>
              <Text style={styles.text1}>
                Date: {FormatDate(formData?.quoteCreatedDate)}
              </Text>
              <Text style={styles.text1}>
                Validity Date: {FormatDate(formData?.validityDate)}
              </Text>
              <Text style={styles.text1}>
                Cargo Value:{" "}
                {getCurrencySymbol(formData?.cargoValue.currency)}
                {AmountFormat(
                  formData?.cargoValue.value,
                  formData.cargoValue.currency
                )}
              </Text>
              <Text style={styles.text1}>
                CIF Value: {getCurrencySymbol(formData?.cifValue.currency)}
                {AmountFormat(
                  formData?.cifValue.value,
                  formData.cifValue.currency
                )}
              </Text>
              <Text style={styles.text1}>
                Transportation Mode: {formData?.modeOfTransfer}
              </Text>
            </View>
          </View>
          <View style={styles.section2}>
            <View style={styles.imgBox}>
              <Image src={goods} style={styles.img} />
              <Text style={styles.title2}>Goods</Text>
            </View>
            {formData.pcsPackage.map((item, index) => (
              <View key={index} style={styles.rowBox}>
                <View style={styles.statBox4}>
                  {index === 0 && (
                    <Text style={styles.statTitle}>Quantity</Text>
                  )}
                  <Text style={styles.statValue}>{item?.quantity || 1}</Text>
                </View>
                <View style={styles.statBox5}>
                  {index === 0 && (
                    <Text style={styles.statTitle}>DIMENSIONS</Text>
                  )}
                  <Text style={styles.statValue1}>
                    {`${item?.length.value} ${item.length?.unit} X ${item?.width.value} ${item.width?.unit} X ${item.height?.value} ${item.height?.unit}`}
                  </Text>
                </View>

                <View style={styles.statBox1}>
                  {index === 0 && (
                    <Text style={styles.statTitle}>Gross Weight</Text>
                  )}
                  <Text style={styles.statValue1}>
                    {(
                      ((parseFloat(item?.quantity) || 0) * (parseFloat(item?.weight?.value) || 0)).toFixed(2)
                    )}{" "}
                    {item?.weight?.unit}
                  </Text>
                </View>

                <View style={styles.statBox1}>
                  {index === 0 && (
                    <Text style={styles.statTitle}>Volume Weight</Text>
                  )}
                  <Text style={styles.statValue1}>
                    {(
                      calculateVolumeWeight(
                        item.length?.value,
                        item.width?.value,
                        item.height?.value,
                        item.length?.unit,
                        item.quantity
                      ).toFixed(2)
                    )}{" "}
                    {item?.weight?.unit}
                  </Text>
                </View>
                <View style={styles.statBox2}>
                  {index === 0 && (
                    <Text style={styles.statTitle}>Chargeable Weight</Text>
                  )}
                  <Text style={styles.statValue1}>
                    {(
                      Math.max(
                        calculateVolumeWeight(
                          item.length?.value,
                          item.width?.value,
                          item.height?.value,
                          item.length?.unit,
                          item.quantity
                        ),
                        (parseFloat(item.quantity) || 0) * (parseFloat(item.weight?.value) || 0)
                      ).toFixed(2)
                    )}{" "}
                    {item?.weight?.unit}
                  </Text>
                </View>

                {/* <View style={styles.statBox1}>
                                    {index === 0 && <Text style={styles.statTitle}>Total Weight</Text>}
                                    <Text style={styles.statValue}>{item?.quantity * item.weight?.value} {item?.weight.unit}</Text>
                                </View> */}
              </View>
            ))}
            <View style={styles.statBox}>
              <Text style={styles.statTitle}> DESCRIPTION</Text>
              <Text style={styles.statValue}>
                {" "}
                {formData.description ? formData?.description : " -"}
              </Text>
            </View>
          </View>

          <View style={styles.section2}>
            <View style={styles.imgBox}>
              <Image source={goods} style={styles.img} />
              <Text style={styles.title2}>Services</Text>
            </View>
            {formData.services.map(
              (service, index) =>
                service.exclVAT > 0 && ( // Add this condition
                  <View style={styles.rowBox} key={index}>
                    <View style={styles.statBox1}>
                      {index === 0 && (
                        <Text style={styles.statTitle}>Quantity</Text>
                      )}
                      <Text style={styles.statValue}>
                        {service?.numberOfItem || "00"}
                      </Text>
                    </View>
                    <View style={styles.statBox3}>
                      {index === 0 && (
                        <Text style={styles.statTitle}>Description</Text>
                      )}
                      <Text style={styles.statValue}>
                        {service?.description || ""}
                      </Text>
                    </View>
                    <View style={styles.statBox1}>
                      {index === 0 && (
                        <Text style={styles.statTitle}>excl.VAT</Text>
                      )}
                      <Text style={styles.statValue}>
                        {getCurrencySymbol(formData?.currency)}{" "}
                        {AmountFormat(service?.exclVAT, formData.currency) ||
                          "00"}
                      </Text>
                    </View>
                    <View style={styles.statBox1}>
                      {index === 0 && (
                        <Text style={styles.statTitle}>Total</Text>
                      )}
                      <Text style={styles.statValue}>
                        {getCurrencySymbol(formData?.currency)}{" "}
                        {AmountFormat(
                          service?.numberOfItem * service.exclVAT,
                          formData.currency
                        ) || "00"}{" "}
                      </Text>
                    </View>
                  </View>
                )
            )}
          </View>

          <View style={styles.totalSection} wrap={false}>
            <View style={styles.totalBox}>
              <View style={styles.totalRow}>
                <View style={styles.totalLabelCol}>
                  <Text style={styles.statTitle}>Subtotal</Text>
                  <Text style={styles.statValue}>VAT %</Text>
                  {/* Insurance removed from here */}
                </View>
                <View style={styles.totalUnitCol}>
                  <Text style={styles.statValue}>{formData.currency}</Text>
                  <Text style={styles.statValue}>
                    {formData?.vatPercentage}%{" "}
                  </Text>
                  {/* Insurance removed from here */}
                </View>
                <View style={styles.totalAmountCol}>
                  <Text style={styles.statValue}>
                    {AmountFormat(formData.subTotal, formData.currency)}
                  </Text>
                  <Text style={styles.statValue}>
                    {AmountFormat(formData.vatAmount, formData.currency)}
                  </Text>
                  {/* Insurance removed from here */}
                </View>
              </View>

              {/* Discount row — only rendered when a discount was applied */}
              {(() => {
                const discount = formData.discount || formData.tradeOSData?.discount;
                if (!discount || !(discount.amount > 0)) return null;
                const discountVal = Math.abs(discount.value);
                return (
                  <View style={styles.discountRow}>
                    <View style={styles.totalLabelCol}>
                      <Text style={styles.discountText}>
                        Discount ({discount.type === 'percentage'
                          ? `${discountVal}%`
                          : `Fixed`})
                      </Text>
                    </View>
                    <View style={styles.totalUnitCol}>
                      <Text style={styles.discountText}>{formData.currency}</Text>
                    </View>
                    <View style={styles.totalAmountCol}>
                      <Text style={styles.discountText}>
                        - {AmountFormat(discount.amount, formData.currency)}
                      </Text>
                    </View>
                  </View>
                );
              })()}

              <View style={styles.totalRow1}>
                <View style={styles.totalLabelCol}>
                  <Text style={styles.statValue}>TOTAL</Text>
                </View>
                <View style={styles.totalUnitCol}>
                  <Text style={styles.statValue}>{formData?.currency}</Text>
                </View>
                <View style={styles.totalAmountCol}>
                  <Text style={styles.statValue}>
                    {AmountFormat(formData.total, formData.currency)}{" "}
                  </Text>
                </View>
              </View>
            </View>
          </View>

          <View fixed style={styles.footerOne} wrap={false}>
            <View style={styles.footerTextContainer}>
              {/* Direct implementation without custom component for more reliable rendering */}
              <Text style={{
                ...styles.footerTextInside,
                fontWeight: 'light', // Using lighter weight to simulate italic appearance
                textDecoration: 'underline', // Adding subtle emphasis since italic isn't working
              }}>
                This quotation and any resulting services are governed by our Terms and Conditions,
              </Text>
              <Text style={{
                ...styles.footerTextUrl,
                fontWeight: 'light', // Using lighter weight to simulate italic appearance
                textDecoration: 'underline', // Adding subtle emphasis since italic isn't working
              }}>
                which are available at https://oneunionsolutions.com/terms-and-conditions/
              </Text>
            </View>
          </View>
        </>
      )}
    </Page>

    {/* Commented out terms page as requested */}
    {/* 
    <Page size="A4" style={styles.page2}>
      <View style={styles.termPage} wrap={false}>
        <Image src={term} style={styles.terms} />
      </View>
    </Page>
    */}
  </Document>
);

export const generatePDF = async (formData, quotationCreatedByAdmin) => {
  const pdfBlob = await pdf(<PDFDocument formData={formData} quotationCreatedByAdmin={quotationCreatedByAdmin} />).toBlob();
  return pdfBlob;
};
